{
  "decrease": "Znížiť {fieldLabel}",
  "increase": "Zvýšiť {fieldLabel}",
  "numberField": "Číselné pole"
}
